import { Component, DestroyRef, ViewChild, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { MaintenanceModeConfiguration } from './maintenance-mode-configuration';
import { AuthenticationService } from '../../../security/authentication.service';
import { NavigationService } from '../../../services/navigation/navigation.service';
import { SelectionService } from '../../../services/selection/selection.service';
import { ModalComponent } from '@rn-platform/frontend-shared-ui-common';
import { MaintenanceModeNotificationModalService } from './maintenance-mode-notification-modal.service';

@Component({
  selector: 'app-maintenance-mode-notification',
  templateUrl: './maintenance-mode-notification.component.html',
  styleUrls: ['./maintenance-mode-notification.component.scss'],
  standalone: false
})
export class MaintenanceModeNotificationComponent implements OnInit {
  authService = inject(AuthenticationService);
  navigationService = inject(NavigationService);
  private selectionService = inject(SelectionService);
  private readonly destroyRef = inject(DestroyRef);


  configuration: MaintenanceModeConfiguration;    
  @ViewChild('modalRef') modalComponent: ModalComponent;    
  modalTitle: string;
  showOrgName = false;
  private readonly maintenanceModeNotificationModalService: MaintenanceModeNotificationModalService = inject(MaintenanceModeNotificationModalService);

  ngOnInit(): void {
   this.maintenanceModeNotificationModalService.modalState$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data) => {
      if (!data) return;
      if (data?.config) {
        this.configuration = data?.config;
         if (this.configuration) {
          this.showOrgName = this.configuration?.State === 'returntotoplevel';
          this.modalTitle = this.getModalTitle();
        }        
      }
      if (data?.isOpen) {
        this.open();
      } else {
        this.close();
      }
    });
  }

  getModalTitle(): string {
    let title = 'Rightworks Maintenance Mode';
    const state = this.configuration?.State;
    if (state === 'returntotoplevel') {
      return title;
    }
    if (state === 'logoutonly') {
      title = `Rightworks services for ${this.configuration?.OrganizationName} are offline for maintenance`;
    }
    return title;
  }  

  async returnToSearch(): Promise<void> {
    this.close();
    await this.navigationService.GoHome();
  }

  removeFromMaintenanceMode(): void {
    this.close();
  }

  async goToTopLevelOrg(): Promise<void> {
    const topLevelOrgID = this.selectionService.getSelectedTopLevelOrg()?.ID;    
    await this.navigationService.OpenOrganization(topLevelOrgID);
    // Forcing reload as navigation doesn't select in tree correctly with soft navigation
    window.location.reload();
    this.close();
  }

  async logout(): Promise<void> {
    this.close();
    await this.navigationService.GoToLoginPage();
    await this.authService.logout();
  }

  open(): void {    
    this.modalComponent?.open();
  }

  close(): void {
    this.modalComponent?.close();
  }
}
